
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/money-fortune/Amber",
      function () {
        return require("private-next-pages/money-fortune/Amber.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/money-fortune/Amber"])
      });
    }
  